 <template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. مربع البحث -->
    <div class="card shadow-sm border-top-primary mb-4 no-print">
      <div class="card-body p-4">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <h4 class="text-center text-primary fw-bold mb-3">
              <i class="fas fa-user-graduate ms-2"></i> الاستعلام الشامل عن الطلاب
            </h4>
            
            <div class="input-group input-group-lg">
              <span class="input-group-text bg-white text-muted">
                <i class="fas fa-search"></i>
              </span>
              <input 
                type="text" 
                v-model="searchQuery" 
                @keyup.enter="performSearch"
                class="form-control fw-bold" 
                placeholder="أدخل رقم الجلوس أو جزء من اسم الطالب..." 
                autofocus
              >
              <button @click="performSearch" class="btn btn-primary px-4 fw-bold" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
                بحث
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. جدول النتائج -->
    <div v-if="students.length > 0" class="card shadow-sm">
      <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
        <h5 class="mb-0 fw-bold text-dark">نتائج البحث ({{ students.length }})</h5>
        <button @click="printPage" class="btn btn-outline-dark btn-sm d-print-none">
          <i class="fas fa-print ms-1"></i> طباعة
        </button>
      </div>
      
      <div class="table-responsive">
        <table class="table table-bordered table-hover text-center align-middle mb-0">
          <thead class="table-dark">
            <tr>
              <th>جلوس</th>
              <th>اسم الطالب</th>
              <th>المدرسة</th>
              <th>اللجنة</th>
              <th>الديانة</th>
              <th>الجنسية</th>
              <th>حالة القيد</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student.id">
              <!-- رقم الجلوس -->
              <td class="fw-bold fs-5 font-monospace">{{ student.seat_no }}</td>
              
              <!-- الاسم -->
              <td class="text-start fw-bold text-primary">{{ student.name }}</td>
              
              <!-- المدرسة -->
              <td class="small fw-bold">{{ student.school }}</td>
              
              <!-- اللجنة -->
              <td>
                <span class="d-block fw-bold">{{ student.committee }}</span>
                <span v-if="student.committee_num" class="badge bg-light text-dark border">
                  لجنة {{ student.committee_num }}
                </span>
              </td>
              
              <!-- الديانة والجنسية -->
              <td>{{ student.religion }}</td>
              <td>{{ student.nationality }}</td>
              
              <!-- حالة القيد (المهمة) -->
              <td>
                <div class="d-flex flex-column gap-1 align-items-center">
                  <!-- نظامي / منازل -->
                  <span 
                    class="badge px-3 py-2 w-100" 
                    :class="student.is_homes ? 'bg-secondary' : 'bg-success'"
                  >
                    {{ student.is_homes ? 'منازل' : 'نظامي' }}
                  </span>

                  <!-- دمج -->
                  <span v-if="student.is_damg" class="badge bg-danger px-3 py-2 w-100">
                    <i class="fas fa-wheelchair ms-1"></i> دمج
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- رسالة عدم وجود نتائج -->
    <div v-else-if="hasSearched && !loading" class="text-center py-5 text-muted animate__animated animate__fadeIn">
      <i class="fas fa-search-minus fa-4x mb-3 opacity-25"></i>
      <h4>لا توجد نتائج مطابقة للبحث</h4>
      <p>تأكد من كتابة رقم الجلوس أو الاسم بشكل صحيح.</p>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "StudentInquiry",
  data() {
    return {
      searchQuery: '',
      loading: false,
      hasSearched: false,
      students: []
    };
  },
  methods: {
    async performSearch() {
      if (!this.searchQuery.trim()) return;

      this.loading = true;
      this.hasSearched = true;
      this.students = [];

      try {
        const res = await api.get('/admin/students/search', {
          params: { query: this.searchQuery }
        });
        this.students = res.data;
      } catch (error) {
        console.error("Search error:", error);
        alert("حدث خطأ أثناء البحث");
      } finally {
        this.loading = false;
      }
    },
    printPage() {
      window.print();
    }
  }
};
</script>

<style scoped>
.border-top-primary {
    border-top: 4px solid #0d6efd;
}

/* تنسيق الطباعة */
@media print {
    .no-print { display: none !important; }
    .card { border: none !important; shadow: none !important; }
    
    /* توسيع الجدول */
    .table-responsive { overflow: visible !important; }
    table { width: 100% !important; font-size: 12pt; }
    th, td { border: 1px solid #000 !important; }
    
    /* إظهار الألوان */
    .badge, .bg-dark, .bg-secondary, .bg-success, .bg-danger {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}
</style>